import { Totals } from "../ApiContracts";
import { axiosHttpClient } from "../AxiosHttpClient";

export const getData = async (): Promise<Totals> => {
  const response = await axiosHttpClient.get(`v1/globaldashboard/data`);
  return response.data;
};
